import { JSX } from 'react'

export default function Header ({
  data,
  level,
  id,
  className,
}: {
  data: string;
  level: number | undefined;
  id: string;
  className: string;
}) {
  const H = `h${level || '3'}` as keyof JSX.IntrinsicElements
  return (
    <H
      id={id}
      dangerouslySetInnerHTML={{ __html: data }}
      className={className}
    />
  )
}
